//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            loading: false,
            readonly: true,
            status: '',
            latestMoveInEvent: '',
            person: {},
            selectedResident: {},
            actual_rent_amount: 0,
            lease_start_date: '',
            lease_expiration_date: '',
            contact_preferences: ['SMS', 'Email', 'Phone'],
            currentEmail: '',
            moveInValidations: [{ model: 'person.person_id', rules: 'required | integer | min:1' }, { model: 'person.first_name', rules: 'required' }, { model: 'person.last_name', rules: 'required' }, { model: 'person.email', rules: 'required' }, { model: 'person.phone', rules: 'required' }, { model: 'person.contact_preference', rules: 'required' }, { model: 'person.unit_id', rules: 'required | integer | min:1' }, { model: 'person.property_id', rules: 'required | integer | min:1' }, { model: 'actual_rent_amount', rules: 'required | integer | min:1' }, { model: 'person.resident_deposit_amount', rules: 'required | integer' }, { model: 'person.prorated_rent', rules: 'required | integer | min:1' }, { model: 'lease_start_date', rules: 'required | before_or_equal:lease_expiration_date' }, { model: 'lease_expiration_date', rules: 'required' }],
            allowedAdminUserRoles: ['super-admin', 'property-manager', 'leasing-consultant', 'regional-manager']
        };
    },
    created: function created() {
        Event.$on('update-resident', this.updateResidentMount);
        Event.$on("delete-entry", function (item) {
            Event.$emit('close-full-modal');
            Event.$emit('resident-list-dashboard-updated');
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('update-resident');
        Event.$off('delete-entry');
    },

    methods: {
        updateResidentMount: function updateResidentMount(item) {
            var $el = this;
            Object.assign(this.$data, this.$options.data());

            $el.latestMoveInEvent = item.latest_move_in_event;
            $el.selectedResident = item;

            $el.$children[0].$data.showModal = true;

            this.person = Object.assign({}, item.person);

            this.person.person_id = item.person.id;
            this.person.first_name = item.person.first_name;
            this.person.last_name = item.person.last_name;
            this.person.phone = item.person.phone;
            this.person.email = item.person.email;
            this.person.contact_preference = item.person.contact_preference;

            this.person.property_id = item.property.id;
            this.person.property_name = item.property.name;
            this.person.unit_id = item.unit.id;
            this.person.unit_name = item.unit.name;

            this.person.resident_deposit_amount = $el.selectedResident.latest_lease.resident_deposit_amount;

            // Note: lease_start_date fires pro-rate calculations and so is handled a little differently; coded this
            // way by intent
            this.lease_start_date = moment($el.selectedResident.latest_lease.lease_start_date).format('MM/DD/YYYY');
            this.lease_expiration_date = moment($el.selectedResident.latest_lease.lease_expiration_date).format('MM/DD/YYYY');

            var total = 0;
            // @TODO: WTF? where did amenities go?
            if (item.unit_amenities && item.unit_amenities.length) {
                item.unit_amenities.forEach(function (amenity) {
                    total += parseInt(amenity.value);
                });
            }
            this.actual_rent_amount = parseInt($el.selectedResident.latest_lease.actual_rent_amount) + total;
            this.cal_prorated_rent();
            this.currentEmail = this.person.email;
        },
        updateResident: function updateResident() {
            var _this = this;

            if (this.currentEmail !== this.person.email && this.canUserChangeEmail()) {
                this.$snotify.confirm('Changing the resident email will remove their bank accounts in the portal. Are you sure?', 'Warning!', {
                    closeOnClick: false,
                    pauseOnHover: true,
                    buttons: [{ text: 'Yes', action: function action() {
                            _this.$snotify.clear();
                            _this.sendUpdateRequest();
                        }
                    }, { text: 'No', action: function action() {
                            _this.person.email = _this.currentEmail;
                            _this.$snotify.clear();
                        }
                    }]
                });
            }

            this.sendUpdateRequest();
        },
        canUserChangeEmail: function canUserChangeEmail() {
            return window.user.role === 'super-admin' || window.user.role === 'property-manager' || window.user.role === 'leasing-consultant' || window.user.role === 'regional-manager';
        },
        sendUpdateRequest: function sendUpdateRequest() {
            var _this2 = this;

            this.$initValidator();
            setTimeout(function () {
                _this2.validator.setRules(_this2.moveInValidations).validate();
                if (_this2.validator.fails()) {
                    return;
                }

                var $el = _this2;
                $el.loading = true;
                _this2.person.personId = _this2.person.person_id;
                _this2.person.firstName = _this2.person.first_name;
                _this2.person.lastName = _this2.person.last_name;
                _this2.person.unitId = _this2.person.unit_id;
                _this2.person.propertyId = _this2.person.property_id;
                _this2.person.contactPreference = _this2.person.contact_preference;
                _this2.person.residentDepositAmount = _this2.person.resident_deposit_amount;
                _this2.person.actualRentAmount = _this2.actual_rent_amount;
                _this2.person.proratedRent = _this2.person.prorated_rent;
                _this2.person.leaseStartDate = moment(_this2.lease_start_date).format('YYYY-MM-DD');
                _this2.person.leaseExpirationDate = moment(_this2.lease_expiration_date).format('YYYY-MM-DD');

                axios.put('/prototype/person/residents/move-ins/' + _this2.person.id, _this2.person).then(function (response) {
                    if (response.data) {
                        $el.loading = false;
                        Event.$emit('resident-list-dashboard-updated');
                        Event.$emit('close-full-modal');
                        Event.$emit('person-updated'); // @TODO: confirm - think resident-list-updated or whatever
                        Object.assign(_this2.$data, _this2.$options.data());
                    }
                });
            });
        },
        leaseStartDateChanged: function leaseStartDateChanged() {
            this.person.lease_expiration_date = this.person.lease_expiration_date ? moment(this.lease_start_date).subtract(1, 'days').add(1, 'years').format("MM/DD/YYYY") : '';
            this.cal_prorated_rent();
        },
        leaseStartExpirationChanged: function leaseStartExpirationChanged() {
            this.cal_prorated_rent();
        },
        cal_prorated_rent: function cal_prorated_rent() {
            var rent_amount = this.actual_rent_amount,
                lease_start_date = this.lease_start_date;

            if (!rent_amount) return 0;
            if (!lease_start_date) return rent_amount;

            lease_start_date = moment(lease_start_date, 'MM/DD/YYYY');

            var endOfMonth = lease_start_date.clone();
            endOfMonth = moment(endOfMonth.add(1, 'months').date(1).format('YYYY-MM-DD'));

            var days = endOfMonth.diff(lease_start_date, 'days');
            var daysInMonth = lease_start_date.daysInMonth();
            this.person.prorated_rent = (rent_amount / daysInMonth * days).toFixed(2);
        },
        canEditContactInfo: function canEditContactInfo() {
            var canDo = this.allowedAdminUserRoles.includes(window.validator.role());

            if (!canDo) {
                this.$snotify.info("Please contact corporate for assistance.");
            }
            return canDo;
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/EditResident.vue
// module id = KW1y
// module chunks = 0 1